import React, { Component } from 'react';
import '../css/App.css'
import chart from 'react-chartjs'
import {convertToPercentage, numFormat, convertToFixedTwo} from '../utils/helper'


class PieChart extends Component {
        
        chartOptions = {
            segmentShowStroke: true,
            segmentStrokeColor: "#fff",
            segmentStrokeWidth: 0.5,
            percentageInnerCutout: 0,
            animationSteps: 100,
            animationEasing: "easeOutBounce",
            animateRotate: true,
            responsive: false,
            maintainAspectRatio: true,
            showScale: true,
            animateScale: true,
            showTooltips: false
            
        }

   componentWillReceiveProps(nextProps){
      //  console.log(nextProps.chartdata)
        if(JSON.stringify(this.props.chartdata) != JSON.stringify(nextProps.chartdata)){
         //   console.log('render')
            this.render()
        }
    }

    render() {
        let PieChart = chart.Pie
        const chartData = this.props.chartdata.map((v) =>
                            ({
                                value: v.percentage,
                                color: v.color,
                                label: v.title,
                                votes: v.votes
                            })) 
        return (
            <div className="col shadow-box">
                {chartData  &&  <div className='row'>
                    <div className='col-md-6' style={{textAlign:'center'}}>
                        {chartData && <PieChart width="250" height="250" data={chartData} options={this.chartOptions} />}
                    </div>
                    <div className='col-md-6'>
                        {chartData && chartData.map(v => (
                            <div key={v.label}>
                                <div className='col-md-12' style={{borderBottom:'1px solid #bfbfba', marginTop:'20px'}}>
                                <div style={{fontWeight:'bold'}}>
                                    <span style={{color:v.color}}><span style={{fontSize:'30px'}}>{convertToFixedTwo(v.value)}</span>%</span>
                                    <span className='float-right' style={{fontSize:'20px',fontWeight: 'bold'}}>{numFormat(v.votes)}</span>
                                </div>
                                <div className='text-right'>
                                    <p style={{color:'#686868'}}>{v.label}</p>
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>
                    </div>
                }
            </div>
        )
    }
}

export default PieChart



// WEBPACK FOOTER //
// ./src/components/PieChart.js